module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize3-52be273873ba6e37f809ce54cdb5d7f9.jpg";